const STORAGE_FIRSTSELECT = "measurement_firstSelect";
const STORAGE_CONSUMPTION = "consumption_state";

const safeSet = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    console.error(`Error guardando ${key}`, e);
  }
};

const normalize = (s) => {
  const str = String(s || "").trim();
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

const uniq = (arr) => Array.from(new Set(arr.filter(Boolean)));

const includesTGBT = (d) => {
  const haystack = [
    d?.name,
    d?.observations,
    d?.equipo?.nombre,
  ]
    .filter(Boolean)
    .join(" ")
    .toUpperCase();

  return haystack.includes("TGBT");
};

const pickPreferredDevice = (devices = []) => {
  if (!Array.isArray(devices) || devices.length === 0) return null;
  const tgbt = devices.find(includesTGBT);
  return tgbt || devices[0];
};

export const buildFirstSelectFromDevice = (d) => {
  const companyName = d?.company?.name || "";
  const officeName = d?.branch_office?.name || "";

  return {
    id: d?.branch_fk,
    company_name: companyName,
    id_company: d?.company_fk ?? null,
    level: "branch_offices",
    names_parents: {
      ...(companyName && { company_name: companyName }),
      ...(officeName && { office_name: officeName }),
    },
  };
};

export const buildDeviceSelectedFromDevice = (d) => {
  return {
    value: d?.id,
    label: String(d?.name || d?.mac || "Device").trim(),
    mac: String(d?.mac || d?.serial_number || "").trim().toUpperCase(),
    data: d,
  };
};

export const autofillFromSingleCurrentDevice = ({
  currentDevices,

  firstSelect,
  setFirstSelect,
  primary,
  setPrimary,
  secondary,
  setSecondary,
  devicesSelected,
  setDevicesSelected,

  startDate,
  endDate,
  frec,
  meterSelected,
}) => {
  if (!Array.isArray(currentDevices) || currentDevices.length === 0) return false;
  const branchIds = uniq(currentDevices.map((d) => d?.branch_fk));
  const hasSingleBranch = branchIds.length === 1;

  const getPrimaryGroup = (d) =>
    d?.primary_group ||
    d?.consumption_group ||
    d?.consumption_group_name ||
    d?.consumption_group?.name ||
    "";

  const primaryGroups = uniq(
    currentDevices
      .map(getPrimaryGroup)
      .map((x) => normalize(x))
      .filter(Boolean)
  );
  const hasSinglePrimaryGroup = primaryGroups.length === 1;

  if (!hasSingleBranch || !hasSinglePrimaryGroup) return false;
  const preferred = pickPreferredDevice(currentDevices);
  if (!preferred) return false;

  let changed = false;
  if (!Array.isArray(firstSelect) || firstSelect.length === 0) {
    const branchObj = buildFirstSelectFromDevice(preferred);
    if (branchObj?.id) {
      const arr = [branchObj];
      setFirstSelect(arr);
      safeSet(STORAGE_FIRSTSELECT, arr);
      changed = true;
    }
  }

  const p = getPrimaryGroup(preferred);

  const s =
    preferred?.secondary_group ||
    preferred?.consumption_sub_group ||
    preferred?.consumption_sub_group_name ||
    preferred?.consumption_sub_group?.name;

  if (!primary && p) {
    setPrimary(normalize(p));
    changed = true;
  }

  if (!secondary && s) {
    setSecondary(normalize(s));
    changed = true;
  }

  if (!Array.isArray(devicesSelected) || devicesSelected.length === 0) {
    const sel = buildDeviceSelectedFromDevice(preferred);
    if (sel?.mac) {
      setDevicesSelected([sel]);
      changed = true;
    }
  }

  if (changed) {
    const payload = {
      startDate: startDate ? startDate.toISOString() : null,
      endDate: endDate ? endDate.toISOString() : null,
      frec: frec || "",
      meterSelected: meterSelected || null,
      primary: primary || (p ? normalize(p) : ""),
      secondary: secondary || (s ? normalize(s) : ""),
      devicesSelected:
        (Array.isArray(devicesSelected) && devicesSelected.length > 0)
          ? devicesSelected
          : [buildDeviceSelectedFromDevice(preferred)],
    };

    safeSet(STORAGE_CONSUMPTION, payload);
  }

  return changed;
};

